import { parse, isValid as isValidDate, format } from 'date-fns';

export const FULL_RX = /^\d{2}\/\d{2}\/\d{4}$/;

/**
 * Returns true if `value` is exactly MM/DD/YYYY and corresponds
 * to a real calendar date.
 */
export function isValidDateString(value: string): boolean {
  if (!FULL_RX.test(value)) {
    return false;
  }
  const date: Date = parse(value, 'MM/dd/yyyy', new Date());
  return isValidDate(date) && format(date, 'MM/dd/yyyy') === value;
}
